import {
  AccordionDetails as MuiAccordionDetails,
  styled
} from "@mui/material";
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  borderTop: "1px solid rgba(0, 0, 0, .125)",
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(0.5),
  padding: theme.spacing(2)
}));
export {
  AccordionDetails
};
//# sourceMappingURL=AccordionDetails.js.map
